// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".footer .footer__quicklinks__group__item a{padding-bottom:8px;transition:all .3s ease-in-out}.footer .footer__quicklinks__group__item a:hover{color:#f1f1f1}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
